enum ActionTypes {
  SET_PRODUCT_AREA = 'Mandates/New/SET_PRODUCT_AREA',
}

export default ActionTypes;
